<ll-titulo>Editar Evaluacion asociada a Generador #{{ generadorInstrumentoId }}</ll-titulo>
<generador-diagnostico-evaluacion-edit [generadorInstrumentoId]="generadorInstrumentoId"
    [_evaluacionId]="evaluacionId"></generador-diagnostico-evaluacion-edit>